<div class="glass-card rounded-4 p-4 shadow-lg">

  <!-- HEADER -->
  <div class="d-flex align-items-center gap-2 mb-3">
    <i class="fas fa-file-alt text-primary fs-6"></i>
    <h6 class="mb-0 fw-semibold text-white text-xs">
      Recent Documents
    </h6>
  </div>

  <!-- DOCUMENT LIST -->
  <div class="d-flex flex-column gap-2">

    <!-- DOCUMENT ITEM -->
    <div
      v-for="doc in documents"
      :key="doc.id"
      class="doc-item d-flex align-items-center justify-content-between rounded-4 px-3 py-2"
    >

      <!-- LEFT -->
      <div class="d-flex align-items-center gap-2">

        <!-- FILE ICON -->
        <div
          class="file-icon d-flex align-items-center justify-content-center rounded-3"
          :class="doc.icon_bg"
        >
          <i :class="doc.icon" class="fs-6"></i>
        </div>

        <!-- DETAILS -->
        <div>
          <p class="fw-semibold text-white text-xs mb-0">
            {{ doc.title }}
          </p>
          <p class="text-white-50 text-xxs mb-0">
            Updated {{ doc.updated }} • {{ doc.size }}
          </p>
        </div>

      </div>

      <!-- DOWNLOAD -->
      <button class="btn btn-link text-white-50 p-0 download-btn">
        <i class="fas fa-download fs-6"></i>
      </button>

    </div>

  </div>
</div>
